import {Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle} from "@mui/material";
import {Button} from "react-bootstrap";
import React, {useState} from "react";
import SpeakerNotesIcon from '@mui/icons-material/SpeakerNotes';
import TextField from '@mui/material/TextField';

function FormDialog(props) {

    const [countCode, setCountCode] = useState(1);
    const [startPrefixCode, setStartPrefixCode] = useState("");

    return (
        <Dialog
            open={props.openDialog}
            onClose={props.handleCloseDialog}
            aria-labelledby="responsive-dialog-title">
            <DialogTitle id="responsive-dialog-title" style={{border:'1px solid #dee2e6' , color: 'sandybrown'}}>
                <div>
                    <p style={{ verticalAlign: 'middle', float: 'left',fontSize: 30,margin: 0,paddingTop: 8,color:props.color}}>{props.title}</p>
                    <SpeakerNotesIcon style={{fontSize: 60, float: 'right', color:props.color}}/>
                </div>
            </DialogTitle>
            <DialogContent style={{paddingTop: '10px', paddingBottom: '10px'}}>
                <DialogContentText>
                    {props.dialogContentText}
                </DialogContentText>

            </DialogContent>
            <TextField
                id="outlined-multiline-static"
                label="Kupon Sayısı"
                type="number"
                style={{padding:'10px'}}
                defaultValue={props.validCountCode}
                value={countCode}
                onChange={(item) => {
                    let value = parseInt(item.target.value, 10);
                    if (value > 1000) value = 1000;
                    if (value < 1) value = 1;
                    setCountCode(value);
                }}
            />
            <TextField
                id="outlined-multiline-static"
                label="Kupon Kodu Anahtarı"
                style={{padding:'10px'}}
                value={startPrefixCode}
                onChange={(item) => {
                        if(item) {
                            let value = item.target.value;
                            if (value.length > 5) return;
                            setStartPrefixCode(value);
                        }
                    }}
            />
            <DialogActions style={{borderTop: '1px solid #dee2e6'}}>
                <Button onClick={() => {
                    props.handleAcceptDialog(countCode,startPrefixCode)}} variant="primary" autoFocus>
                    Tamam
                </Button>
                <Button onClick={props.handleCloseDialog} variant="danger">
                    İptal
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default FormDialog;